import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import NoResultsOverlay from '../Errors/NoResultsOverlay';
import MarkdownLinkRenderer from '../shared/MarkdownLinkRenderer';
import MarkdownParagraphRenderer from '../shared/MarkdownParagraphRenderer';
import RecruitmentPageTabSkeleton from './RecruitmentPageTab.skeleton';

const RecruitmentPageTab = ({
	tab,
	page = undefined,
	resultCode = 0,
	statusCode = 0,
	isError = false,
	isSelected = false,
	isLoading = false,
}) => {
	const theme = useTheme();
	const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));
	const showNoResultsOverlay =
		isError || (statusCode >= 400 && statusCode <= 505);

	return (
		<div
			role='tabpanel'
			hidden={!isSelected}
			id={`simple-tabpanel-${tab.id}`}
			key={tab.id}
			aria-labelledby={`simple-tab-${tab.id}`}
		>
			{isSelected && (
				<Box mx={isExtraSmall && 2}>
					<Typography
						component='h1'
						variant='h4'
						color='primary.main'
						fontWeight={500}
					>
						{tab.pageTitle || tab.label}
					</Typography>
					{isLoading && <RecruitmentPageTabSkeleton />}
					{showNoResultsOverlay && (
						<Container sx={{ pt: 3 }}>
							<NoResultsOverlay
								resultCode={resultCode}
								statusCode={statusCode}
							/>
						</Container>
					)}
					{!isLoading && !showNoResultsOverlay && (
						<ReactMarkdown
							components={{
								a: MarkdownLinkRenderer,
								p: MarkdownParagraphRenderer,
							}}
						>
							{page
								? page.body
								: "We're sorry, something went wrong. We're unable to load the results at this time. Please refresh and try again."}
						</ReactMarkdown>
					)}
				</Box>
			)}
		</div>
	);
};

RecruitmentPageTab.propTypes = {
	tab: PropTypes.object.isRequired,
	page: PropTypes.object,
	resultCode: PropTypes.number,
	statusCode: PropTypes.number,
	isError: PropTypes.bool,
	isSelected: PropTypes.bool,
	isLoading: PropTypes.bool,
};

export default RecruitmentPageTab;
